import { Alert, AlertTitle, Box, SxProps, useMediaQuery, useTheme } from "@mui/material"
import React from "react";

// used for wrapping the contents of a page (minus the header). applies page padding consistently and adjusts for mobile vs desktop layouts
export const PageContainer: React.FC<{ children: React.ReactNode, sx?: SxProps}> = ({ children, sx }) => {
  const md = useMediaQuery((theme) => theme.breakpoints.up('md'));
  
  return <Box sx={{ width: '700px', maxWidth: '100%', p: md ? 3 : 1, pt: md ? 3 : 2, flexGrow: 1, ...sx }}>{children}</Box>
}

type PageDescriptorProps = {
  title: string;
  icon?: React.ReactNode;
  children: React.ReactNode;
}

export const PageDescriptor: React.FC<PageDescriptorProps> = ({ title, icon, children }) => {
  const theme = useTheme();

  return <Alert variant="outlined" severity="theme" icon={icon} sx={{ mb: 2, border: 'none', color: theme.palette.text.primary }}>
    <AlertTitle>{title}</AlertTitle>
    {children}
  </Alert>
}